import _ from 'lodash';
import { connect } from 'react-redux';
import { split, search } from '../../modules/billing/splitBillPage';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state) => {
	/** @namespace state.lists.splitBillPageIds **/
	/** @namespace state.maps.splitBillPage **/
	let splitBillPages = undefined;
	if (state.lists.splitBillPageIds) {
		splitBillPages = _.map(state.lists.splitBillPageIds, id => state.maps.splitBillPage[id]);
	}
	const canMakeUpdates = !!(_.get(state.auth.authUser, ['permissions', 'canMakeUpdates'], false));
	return {
		splitBillPages,
		userMap : state.maps.user,
		resourceMap : state.maps.resource,
		canMakeUpdates,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	splitMultiPageBill : split,
	searchSplitBillPages : search,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
